/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import { Maybe } from 'purify-ts';
import { getUniqueId } from '@/utils';
import { errOrData, isEmpty } from './utils';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class BaseAutoTestStep {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    trackingId;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    id;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    description;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    name;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    type;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    weight;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    hidden;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    redacted;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    data;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    suite;
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(data) {
        this.id = data.id;
        this.description = data.description;
        this.name = data.name;
        this.type = data.type;
        this.weight = data.weight;
        this.hidden = data.hidden;
        this.data = data.toParse ? this.parseInputData(data.data) : data.data;
        this.suite = data.suite;
        this.trackingId = data.trackingId.orDefaultLazy(getUniqueId);
        this.redacted = data.redacted;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _update(data) {
        const newData = {
            id: this.id,
            description: data.description ?? this.description,
            name: data.name ?? this.name,
            type: this.type,
            weight: data.weight ?? this.weight,
            hidden: data.hidden ?? this.hidden,
            data: data.data ?? this.data,
            suite: this.suite,
            trackingId: Maybe.of(this.trackingId),
            toParse: false,
            redacted: this.redacted,
        };
        // @ts-expect-error: We cannot create an instance of
        // `BaseAutoTestStep` as it is an abstract class so ts will
        // complain here.
        return new this.constructor(newData);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    update(data) {
        return this._update(data);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    updateData(partialData) {
        return this._update({
            data: {
                ...this.data,
                ...partialData,
            },
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _checkProgramNotEmpty() {
        if (isEmpty(this.data.program)) {
            return ['The program may not be empty'];
        }
        return [];
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    _baseGetDataToSave() {
        const errs = [];
        if (isEmpty(this.name)) {
            errs.push('The name may not be empty.');
        }
        if (Number(this.weight) < 0) {
            errs.push('The weight should not be negative.');
        }
        return errOrData(errs, {
            name: this.name,
            id: this.id.extract(),
            description: this.description,
            hidden: this.hidden,
            weight: this.weight,
        });
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    equals(other) {
        if (this.id.isJust() && other.id.isJust()) {
            return this.id.equals(other.id);
        }
        return this.trackingId === other.trackingId;
    }
}
